import { PermissionT } from "../types";

export const portalAccess = (permissions: PermissionT[]): boolean => {
  const p = permissions.find((permission) => permission.name === "portal_access");
  return !!p;
};

export default portalAccess;
